
<div :id="content.idHTML">
  <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
  <ValidationObserver tag="div">
    <ValidationProvider
      v-slot="validationContext"
      name="optionChoisi"
      :rules="reglesOptions"
      tag="div"
    >
      <fieldset
        :id="idFieldset"
        class="font-radio-btn customRadio radio-general spaceBetweenRadioBtn"
        :aria-labelledby="idFieldset + '-legend'"
      >
        <legend :id="idFieldset + '-legend'" class="sr-only">
          {{ 'Choisissez une option' }}
        </legend>
        <div class="row mx-0" role="radiogroup" :aria-labelledby="idFieldset + '-legend'">
          <template v-for="(item, index) in options">
            <div
              :key="cat + item.value"
              class="align-items-center blanc-bg"
              :class="[
                content.choixParLigne == 1 ? 'd-flex' : 'd-inline-flex',
                {
                  'col px-0 text-center': content.format == 'tableau',
                },
              ]"
            >
              <input
                :id="cat + item.value"
                :key="index"
                v-model="optionChoisi"
                type="radio"
                :value="item.value"
                :aria-label="item.value"
                :name="item.name"
                class="m-0"
                :class="{ 'd-none': content.format == 'tableau' }"
                :aria-describedby="'option-live-feedback'"
                :aria-checked="optionChoisi === item.value ? 'true' : 'false'"
                :aria-labelledby="cat + item.value"
              />
              <label
                :key="item.text"
                :for="cat + item.value"
                tabindex="0"
                :aria-label="item.value + '-label'"
                class="label-input"
                :title="item.text"
                :class="[
                  { tableau: content.format == 'tableau' },
                  { premier: index == 0 },
                  { dernier: index == options.length - 1 },
                ]"
                @keyup.enter="onPress($event)"
                v-html="item.text"
              />
            </div>
          </template>
        </div>
      </fieldset>
      <ErreurValidation
        id="option-live-feedback"
        :message="validationContext.errors[0]"
      ></ErreurValidation>
    </ValidationProvider>
    <div v-if="content.libAutre !== undefined && selectionAutre === true" class="pt-1">
      <transition name="fade">
        <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
        <ValidationProvider
          v-slot="validationContext"
          ref="validator"
          :mode="customValidation"
          name="optionAutre"
          :rules="reglesAutre"
          tag="div"
        >
          <!-- Si montant autre -->
          <b-form-group v-show="selectionAutre">
            <div v-if="content.type == 'monetaire'" class="row col-6 col-md-4">
              <legend class="texte texte-padding" label-for="optionAutre">
                {{ content.libAutre }}
              </legend>
              <div class="input-group">
                <money
                  id="optionAutre"
                  ref="optionAutre"
                  v-model="optionAutre"
                  :aria-label="content.libAutre"
                  maxlength="7"
                  v-bind="$t('vMoneySansDecimales')"
                  class="form-control pb-0 pt-0"
                  :class="{ 'is-invalid': validationContext.errors.length > 0 }"
                  aria-invalid="true"
                  aria-describedby="message-limite-depot-invalide"
                  @blur.native="forceValidate()"
                />
              </div>
            </div>
            <div v-else-if="content.type == 'heure'" class="input-group mb-3">
              <b-form-input
                :id="content.idHTML + 'optionAutre'"
                v-model="optionAutre"
                :type="typeInput"
                class="form-control pt-0"
                :class="{
                  'is-invalid': validationContext.errors.length > 0, // Attention si on ne met pas ceci les erreurs n'aparaissent pas pour v-money...
                }"
                :aria-describedby="'option-live-feedback'"
                :aria-checked="optionAutre === item.value ? 'true' : 'false'"
                :aria-labelledby="'autre-label'"
                @blur.native="validationContext.validate()"
              />
              <div class="input-group-append">
                <span
                  class="input-group-text border-left-0 is-valid"
                  :class="{ 'is-invalid': validationContext.errors.length > 0 }"
                  >h</span
                >
              </div>
            </div>
            <!-- Utilisé le 'number' pour les limites bien jouer -->
            <div v-else-if="content.type == 'number'" class="d-flex justify-content-end mt-3">
              <div class="">
                <div class="input-group-limite">
                  <div
                    v-if="$i18n.locale == 'en' && content.unite != 'h'"
                    class="input-group-append-limite"
                  >
                    {{ content.unite }}
                  </div>
                  <money
                    id="optionAutre"
                    ref="optionAutre"
                    v-model="optionAutre"
                    :aria-label="content.libAutre"
                    :maxlength="content.inputLength"
                    autocomplete="off"
                    v-bind="$t('vMoneySansDecimalesDollars')"
                    class="form-control form-control-limite pb-0 pt-0"
                    :class="{ 'is-invalid': validationContext.errors.length > 0 }"
                    aria-invalid="true"
                    aria-describedby="message-limite-depot-invalide"
                    @change.native="validateChange()"
                    @blur.native="forceValidateInput()"
                  />
                  <div
                    v-if="$i18n.locale == 'fr' || content.unite == 'h'"
                    class="input-group-append-limite"
                  >
                    {{ content.unite }}
                  </div>
                </div>
                <div
                  v-show="validationContext.errors.length == 0"
                  class="info-lib-msg justify-content-end mb-1"
                >
                  {{ content.minMaxValues.validationMsg }}
                </div>
              </div>
            </div>
            <b-form-input
              v-else
              :id="content.idHTML + 'optionAutre'"
              v-model="optionAutre"
              :type="typeInput"
              class="form-control pt-0"
              :class="{
                'is-invalid': validationContext.errors.length > 0,
              }"
              @blur.native="validationContext.validate()"
            />
            <ErreurValidation
              id="message-limite-depot-invalide"
              :message="validationContext.errors[0]"
              :variables="variablesRemplacement"
              :class="content.type == 'number' ? 'd-flex justify-content-end' : ''"
              aria-live="assertive"
            ></ErreurValidation>
          </b-form-group>
        </ValidationProvider>
      </transition>
    </div>
  </ValidationObserver>
</div>
